import { BOOL, SI_ROUTER } from "../constants/LocalStorageMap";
import LocalStorageService from "../service/LocalStorageService";

/**
 * Reads the `siRouter` opt-in flag from localStorage (same idiom as `siDebugJSON` / `siDevTools`).
 * @returns {boolean}
 */
export const readSiRouterFlag = () => LocalStorageService.get(SI_ROUTER, BOOL);
